/* eslint-disable eqeqeq */
import { Clock, Verified, XOctagon } from "lucide-react";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { API, fileUpload } from "../../config";
import CustomTooltip from "../CustomTooltip";
import Confirmation from "../Confirmation";

const CDDStatus = ({ data, type, contactType, id, fetchData, cdd }) => {
  const [loading, setLoading] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const toggleShowStatus = () => {
    setShowStatus(!showStatus);
  };

  const handleStatus = async (status) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("status", status);
      formData.append("type", type);
      await fileUpload(`${API.GET_CDD_STATUS}/${id}`, formData);
      setLoading(false);
      fetchData();
      toggleShowStatus();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  return data?.source === "Visual" ||
    data?.source === "KYB" ||
    data?.source === "ATO" ||
    data?.source === "Multiple" ? (
    <></>
  ) : (
    data?.source && (
      <div className="flex items-center gap-2 justify-center">
        {data?.[type] === 1 ? (
          <>
            <span>
              <Verified size={18} className="text-green-500" />
            </span>{" "}
            <span>/</span>
          </>
        ) : data?.[type] === 2 ? (
          <>
            <span>
              <Clock size={18} className="text-yellow-500" />
            </span>{" "}
            {/* <span>/</span> */}
          </>
        ) : data?.[type] === 0 ? (
          <>
            <span>
              <XOctagon size={18} className="text-red-500" />
            </span>
            <span>/</span>
          </>
        ) : (
          ""
        )}

        {data?.[type] != null && data?.[type] != 2 && (
          <CustomTooltip message={`${type.toUpperCase()} Edit`}>
            <span>
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                onClick={() => {
                  toggleShowStatus();
                }}
              />
            </span>
          </CustomTooltip>
        )}

        <Confirmation
          title={`${type.toUpperCase()} Change`}
          open={showStatus}
          setOpen={setShowStatus}
          toggleShow={() => {
            toggleShowStatus();
          }}
          className="sm:max-w-fit"
          popupType={"cdds"}
          message={
            <>
              <p>
                {type == "pep"
                  ? `Is this ${contactType} a Politically Exposed Person (PEP)?`
                  : type == "sanction"
                    ? `Does this ${contactType} have a sanctions match?`
                    : type == "dvs"
                      ? `Has this ${contactType} identity been verified through DVS?`
                      : type == "bureau"
                        ? `Does this ${contactType} have a bureau match?`
                        : ""}
              </p>
              <p>
                Please review the available information before confirming the{" "}
                {contactType} PEP status. <br /> Your selection will be recorded
                and may affect the {contactType} risk assessment.
              </p>
              <p>
                By clicking{" "}
                {type == "pep" || type == "sanction"
                  ? cdd == "simplified"
                    ? "Yes"
                    : "No"
                  : cdd == "simplified"
                    ? "No"
                    : "Yes"}
                , this client will be moved to the{" "}
                {cdd == "simplified" ? "Enhanced" : "Simplified"} Customer Due
                Diligence (ECDD) category.
              </p>
            </>
          }
          okAction={async () => {
            await handleStatus(type == "pep" || type == "sanction" ? 0 : 1);
          }}
          loading={loading}
          cancelAction={async () => {
            await handleStatus(type == "pep" || type == "sanction" ? 1 : 0);
          }}
          extraButton={true}
          extraButtonAction={() => {
            toggleShowStatus();
          }}
        />
      </div>
    )
  );
};

export default CDDStatus;
